import React, { Fragment, useState, useEffect, useContext } from 'react'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import { numberFormat } from '../../../services/posts'
import useToastContext from "../../../hooks/useToastContext"
import { Helmet } from "react-helmet-async"

import moment from "moment"
import { BannerStatusBages, BannerActionButtons, PlacementTotalBy } from './common'
import { BannerPreview } from './Form'

const bannerProperty = (banner, property, defaultValue) => {
    return banner.options && banner.options.settings && banner.options.settings[property] ? banner.options.settings[property] : defaultValue
}

const BannerStats = ({ banner }) => {

    const duration = banner ? moment(banner.expires_at).diff(moment(banner.starts_at), 'days') + 1 : null

    return (
        <div className="row">
            <div className="col-md-4">
                {banner.starts_at && banner.expires_at ? (
                    <div className="card mb-3">
                        <div className="card-body text-center">
                            <div>{moment(banner.starts_at).format('M/DD/YYYY')} - {moment(banner.expires_at).format('M/DD/YYYY')}</div>
                            <h2 className="display-4">{duration}<small className="text-muted"><small><small>days</small></small></small></h2>
                        </div>
                    </div>
                ) : (
                    <div className="card mb-3">
                        <div className="card-body text-center">
                            <div>No dates limits</div>
                            <h2 className="display-4">∞</h2>
                        </div>
                    </div>
                )}
            </div>
            <div className="col-md-4">
                <div className="card mb-3">
                    <div className="card-body text-center">
                        <div>Views</div>
                        <h2 className="display-4">{numberFormat(banner.views)}</h2>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card mb-3">
                    <div className="card-body text-center">
                        <div>Clicks</div>
                        <h2 className="display-4">{numberFormat(banner.clicks)}</h2>
                    </div>
                </div>
            </div>
        </div>
    )
}

const BannerView = ({ match, history }) => {

    const { data, authServices, location, bannerServices } = useContext(AppContext)
    const { user } = data.app

    const addToast = useToastContext()

    const bannerId = match.params.id
    const title = "View Banner Ad"

    const [ isChecked, setIsChecked ] = useState(false)

    const [ placement, setPlacement ] = useState(null)
    const [ banner, setBanner ] = useState(null)
    const [ locations, setLocations ] = useState([])
    const [ categories, setCategories ] = useState([])
    const [ images, setImages ] = useState([])

    useEffect(() => {
        bannerServices.show(bannerId, {placement: 'y'}).then(res => {
            setBanner(res.banner)
            setIsChecked(true)
        }).catch(res => {
            console.log('error')
            console.log(res)
            setIsChecked(true)
        })
    }, [])

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4 overflow-hidden">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/banner/list', title: 'Banner ads list'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between flex-wrap mb-3">
                            <div className="me-3">
                                <h1 className="mt-0">
                                    <span className="me-2">{banner && ('#' + banner.id)} {title}</span>
                                    <BannerStatusBages banner={banner} />
                                </h1>
                            </div>
                            <BannerActionButtons banner={banner} page={'view'} />
                        </div>

                        {banner &&
                            <Fragment>
                                <PlacementTotalBy banner={banner} page="view" />
                                <BannerStats banner={banner} />
                                <h3>Banner Preview</h3>
                                <div className='banner-preview-iframe'>
                                    <div className="bp-inner">
                                        <iframe src={'/banner/view/' + banner.id}></iframe>
                                    </div>
                                </div>
                            </Fragment>
                        }

                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default BannerView
